// extracted by mini-css-extract-plugin
module.exports = {"button":"PoGroupLabelPrintButton_button__3BBUj","button-ltr":"PoGroupLabelPrintButton_button-ltr__oIYuw"};